import React, { createContext, useContext, ReactNode } from 'react';
import { ExperimentsResult } from './server';

interface AmplitudeContextValue {
  experiments: ExperimentsResult;
}

const AmplitudeContext = createContext<AmplitudeContextValue>({
  experiments: {},
});

interface AmplitudeProviderProps {
  children: ReactNode;
  experiments: ExperimentsResult;
}

export function AmplitudeProvider({ children, experiments }: AmplitudeProviderProps): JSX.Element {
  return <AmplitudeContext.Provider value={{ experiments }}>{children}</AmplitudeContext.Provider>;
}

export function useAmplitudeContext(): AmplitudeContextValue {
  const context = useContext(AmplitudeContext);
  if (!context) {
    throw new Error('useAmplitudeContext must be used within AmplitudeProvider');
  }
  return context;
}
